import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

const publicStorage = publicRuntimeConfig.NEXT_PUBLIC_STORAGE_PATH;

export const getUrlWithPublicStorage = (urlPath?: string) => urlPath ? `${publicStorage}${urlPath}` : '';